import { GET_LIST_ANGKUTSAMPAH } from '../../actions/AngkutSampahAction';

const initialState = {
  getListAngkutSampahLoading: false,
  getListAngkutSampahResult: false,
  getListAngkutSampahError: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LIST_ANGKUTSAMPAH:
      return {
        ...state,
        getListAngkutSampahLoading: action.payload.loading,
        getListAngkutSampahResult: action.payload.data,
        getListAngkutSampahError: action.payload.errorMessage,
      };

    default:
      return state;
  }
}
